import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Box, Container, Desktop } from '@miro-site/core';
import CategoryNav, { Button as CategoryNavButton } from '../category-nav/CategoryNav';
import Search, { SearchWrapper as SearchInputWrapper } from '../search/Search';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TopBarWrapper = styled(Box).attrs(function (_ref) {
  var theme = _ref.theme,
      $isFixed = _ref.$isFixed,
      _ref$$styles = _ref.$styles,
      $styles = _ref$$styles === void 0 ? {} : _ref$$styles;
  return {
    $styles: _objectSpread(_objectSpread({}, $isFixed ? {
      position: 'fixed',
      paddingTop: [8, 17, 17, 17],
      paddingBottom: [8, 17, 17, 17],
      boxShadow: theme.templates.elevation.topBar,
      backgroundColor: 'primaryWhite',
      top: 0,
      right: 0,
      left: 0,
      zIndex: 700
    } : {
      position: 'relative'
    }), $styles)
  };
}).withConfig({
  displayName: "TopBar__TopBarWrapper",
  componentId: "sc-xj3y8g-0"
})({});
var TopBarSearch = styled(Search).withConfig({
  displayName: "TopBar__TopBarSearch",
  componentId: "sc-xj3y8g-1"
})(["", ""], function (_ref2) {
  var $isActive = _ref2.$isActive,
      $isFixed = _ref2.$isFixed,
      theme = _ref2.theme;
  return $isActive && $isFixed && css(["", "{box-shadow:", ";}"], SearchInputWrapper, theme.templates.elevation.fixedSearch);
});

var TopBar = function TopBar(_ref3) {
  var rootGroups = _ref3.rootGroups,
      onSearch = _ref3.onSearch,
      searchResult = _ref3.searchResult,
      statusMessages = _ref3.statusMessages,
      isSearching = _ref3.isSearching,
      onCategoryNavOpened = _ref3.onCategoryNavOpened,
      onSelectTemplate = _ref3.onSelectTemplate,
      onSelectCategory = _ref3.onSelectCategory,
      backButton = _ref3.backButton,
      categoriesButtonLabel = _ref3.categoriesButtonLabel,
      _ref3$isSticky = _ref3.isSticky,
      isSticky = _ref3$isSticky === void 0 ? false : _ref3$isSticky;

  var _useState = useState(false),
      categoryNavOpened = _useState[0],
      setCategoryNavOpened = _useState[1];

  var _useState2 = useState(false),
      isSearchActive = _useState2[0],
      setSearchActive = _useState2[1];

  var navRef = useRef(null);
  var navButtonRef = useRef(null);

  var handleClick = function handleClick(e) {
    var clickOnNavButton = navButtonRef.current && navButtonRef.current.contains(e.target);

    if (clickOnNavButton) {
      return;
    }

    var clickOutsideNav = navRef.current && !navRef.current.contains(e.target);

    if (clickOutsideNav) {
      setCategoryNavOpened(false);
    }
  };

  useEffect(function () {
    if (!categoryNavOpened) {
      return;
    }

    if (onCategoryNavOpened) {
      onCategoryNavOpened();
    }

    document.addEventListener('click', handleClick, true);
    window.addEventListener('focusin', onFocusCategoryDown);
    return function () {
      document.removeEventListener('click', handleClick, true);
      document.removeEventListener('keydown', onFocusCategoryDown);
    };
  }, [categoryNavOpened]);

  var onKeyDownHandler = function onKeyDownHandler(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      setCategoryNavOpened(!categoryNavOpened);
    }
  };

  var onFocusCategoryDown = function onFocusCategoryDown() {
    if (navRef.current && document.activeElement !== navButtonRef.current && !navRef.current.contains(document.activeElement)) {
      setCategoryNavOpened(false);
    }
  };

  var searchContainerStyles = {
    width: !isSearchActive ? [40, 394, 394, 394] : '100%',
    marginLeft: ['auto', 0, 0, 0],
    position: 'relative'
  };
  return /*#__PURE__*/_jsx(TopBarWrapper, {
    $isFixed: isSticky,
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Box, {
        $styles: {
          justifyContent: backButton ? 'flex-start' : 'center',
          alignItems: 'center',
          display: 'flex',
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsxs(_Fragment, {
          children: [backButton && /*#__PURE__*/_jsx(Desktop, {
            $mr: "auto",
            $styles: {
              position: isSearchActive ? 'absolute' : 'relative'
            },
            children: backButton
          }), /*#__PURE__*/_jsx(CategoryNavButton, {
            ref: navButtonRef,
            $mr: 12,
            isOpened: categoryNavOpened,
            onClick: function onClick() {
              setCategoryNavOpened(!categoryNavOpened);
            },
            onKeyDown: onKeyDownHandler,
            isSearchActive: isSearchActive,
            children: categoriesButtonLabel
          })]
        }), /*#__PURE__*/_jsx(CategoryNav, {
          ref: navRef,
          isVisible: categoryNavOpened,
          rootGroups: rootGroups,
          onMobilePopupClose: function onMobilePopupClose() {
            setCategoryNavOpened(false);
          },
          onCategoryOpen: function onCategoryOpen(category) {
            setCategoryNavOpened(false);

            if (onSelectCategory) {
              onSelectCategory(category);
            }
          }
        }), /*#__PURE__*/_jsx(Box, {
          $styles: searchContainerStyles,
          children: /*#__PURE__*/_jsx(TopBarSearch, {
            $isActive: isSearchActive,
            $isFixed: isSticky,
            onSearch: onSearch,
            searchResult: searchResult,
            statusMessages: statusMessages,
            isSearching: isSearching,
            onSelectTemplate: onSelectTemplate,
            onFocusChanged: function onFocusChanged(isFocused) {
              setSearchActive(isFocused);

              if (isFocused) {
                setCategoryNavOpened(false);
              }
            }
          })
        })]
      })
    })
  });
};

export default TopBar;